export const tableHeaders = [
  'ID',
  'User Email',
  'Game Name',
  'Action Type',
  'Amount',
  'Amount Type',
  'Before Balance',
  'After Balance',
  // 'Status',
  'Created At'
]

export const transactionType = [
  { label: 'Select Transaction Type', value: 'all' },
  { label: 'Bet', value: 'bet' },
  { label: 'Win', value: 'win' },
  { label: 'Lost', value: 'lost' },
  { label: 'Refund', value: 'refund' },
  { label: 'Cashout', value: 'cashout' },
  { label: 'StakeDecrease', value: 'stakeDecrease' },
  { label: 'NewDebit', value: 'newDebit' },
  { label: 'NewCredit', value: 'newCredit' },
  { label: 'AwardBonus', value: 'awardBonus' }
]

export const statusType = [
  { label: 'All', value: 'all' },
  { label: 'Pending', value: 'pending' },
  { label: 'Complete', value: 'completed' },
  { label: 'Failed', value: 'failed' },
  { label: 'RollBack', value: 'rollback' }
]

export const AMOUNT_TYPE = {
  0: 'Cash',
  1: 'Non Cash',
  2: 'Cash and Non Cash'
}

export const tableCasinotransactionColumns = [
  { label: 'ID', value: 'casinoTransactionId', Header: 'id', accessor: 'id', isTooltipEnabled: false },
  { label: 'User Email', value: 'email', Header: 'User Email', accessor: 'email', isTooltipEnabled: false },
  { label: 'User Name', value: 'username', Header: 'User Name', accessor: 'username', isTooltipEnabled: false },

  { label: 'Transaction Type', value: 'transactionType', Header: 'Transaction Type', accessor: 'transactionType', isTooltipEnabled: false }, // referenceNumber
  { label: 'Odds', value: 'odds', Header: 'odds', accessor: 'Odds', isTooltipEnabled: false }, // referenceNumber

  { label: 'Bet Reference Id', value: 'referenceNumber', Header: 'Bet Reference Id', accessor: 'referenceNumber', isTooltipEnabled: false }, // referenceNumber

  { label: 'Current Balance', value: 'currentBalance', Header: 'Current Balance', accessor: 'currentBalance', isTooltipEnabled: false },
  { label: 'Bet Slip Status', value: 'betslipStatus', Header: 'Bet Slip Status', accessor: 'betslipStatus', isTooltipEnabled: false },
  { label: 'Amount', value: 'amount', Header: 'Amount', accessor: 'amount', isTooltipEnabled: false },
  { label: 'Non Cash Amount', value: 'nonCashAmount', Header: 'Non Cash Amount', accessor: 'nonCashAmount', isTooltipEnabled: false },
  { label: 'Stake', value: 'stake', Header: 'Stake', accessor: 'stake', isTooltipEnabled: false, tooltip: "Stake" },
  { label: 'Bet Mode', value: 'betMode', Header: 'Bet Mode', accessor: 'betMode', isTooltipEnabled: false },
  { label: 'Event', value: 'events', Header: 'Event', accessor: 'events', isTooltipEnabled: false },

  // { label: 'Game Name', value: 'gameReference', Header: 'Game Name', accessor: 'gameReference' },
  { label: 'Created At', value: 'createdAt', Header: 'Created At', accessor: 'createdAt', isTooltipEnabled: false }
];


export const betStatus = [
  { label: 'Select Bet Slip Status	', value: 'all' },
  { label: 'Open', value: 'Open' },
  { label: 'Won', value: 'Won' },
  { label: 'Lost', value: 'Lost' },
  { label: 'Void', value: 'Void' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Waiting for client', value: 'Waiting for client' },
  { label: 'Rejected', value: 'Rejected' },
  { label: 'Cashout', value: 'Cashout' },
  { label: 'Partial cashout', value: 'Partial cashout' },
  { label: 'Rejected by regulator (MTS)', value: 'Rejected by regulator (MTS)' },
  { label: 'Rejected by Portal', value: 'Rejected by Portal' },

];


export const sportsBookTransactionTypes = {
  SportsBookBet: 'bet',
  SportsBookWin: 'win',
  SportsBookRefund: 'refund',
  SportsBookCashout: 'cashout',
  SportsBookStakeDecrease: 'stakeDecrease',
  SportsBookNewDebit: 'newDebit',
  SportsBookNewCredit: 'newCredit',
  SportsBookAwardBonus: 'awardBonus',
  SportsBookLost: "lost"
};
